import React, { FC, useContext, useRef, useState } from "react";
import { AuthContext } from "../../providers/AuthProvider";
import { DCDialog } from "../Wrappers/DCDialog";
import { DelayEntry } from "../DelayEntry/DelayEntry";
import { ReactSVG } from "react-svg";
import { AircraftInput } from "../AircraftInput/AircraftInput";
import { AircaftData } from "../../Model/AircraftData";
import { DCInput } from "../Wrappers/DCInput";
import "./AddEntry.scss";
import { useSelector } from "react-redux";
import { DelayListRecordWithAction } from "../../Model/DelayListRecordWithAction";

interface AddEntryFormProps {
  expanded?: boolean;
  searchDate: string;
  onDelayEntryDialogClose: () => void;
  onSaveFlightDelayDetail: (savedRecord: DelayListRecordWithAction) => void;
}

export const AddEntry: FC<AddEntryFormProps> = ({
  searchDate,
  expanded = false,
  onDelayEntryDialogClose,
  onSaveFlightDelayDetail,
}) => {
  const plusIcon = "https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/interface/plus-lg.svg";
  const chevronDown =  "https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/interface/chevron-down.svg";

  const {
    getAccessToken,
    getAdminStatus,
    getMaintainerStatus,
    getReviewerStatus,
  } = useContext(AuthContext);
  const [isExpanded, setIsExpanded] = useState(expanded);
  const [aircraftvalue, setAircraftValue] = useState("");
  const [depflightvalue, setDepFlightValue] = useState("");
  const [stationvalue, setStationValue] = useState("");

  const [openDialog, setDialogOpen] = useState(false);
  const [isAircraftValid, setIsAircraftValid] = useState(true);
  const [errorMessage, setErrorMessag] = useState("");

  const [airlineCode, setAirlineCode] = useState("");
 const aircraftList = useSelector((state: any) => state.aircraftState.aircraftList);  
  // Create a ref
  const acInputRef = useRef<HTMLInputElement | null>(null);

  const addDelayEntryEventHandler = (data: string) => {
    console.info("DC entry Data added: " + data);
    //setDialogOpen(false);
  };

  /** User clicks cancel button in the dialog window */
  const cancelDelayEntryEventHandler = () => {
    console.info("DC entry cancelled");
    setDialogOpen(false);
    onDelayEntryDialogClose();
  };
  
  const deleteRuleEventHandler=()=>{
    setDialogOpen(false);
    onDelayEntryDialogClose();
  }
  const errorDelayEntryEventHandler = (data: string) => {
    //setDialogOpen(false);
  };

  return (
    <>
      <div className="ComponentDelayListAdd">
        {isExpanded && (
          <>
            <div className="ComponentFooterHeader">
              <span className="DelayListFooterHeader">
                To ADD a new entry: input your selected flight's values, then
                push 'Add Entry' button
              </span>
            </div>
            <div className="ComponentDelayListAddInputAC">
              <div>
                <AircraftInput
            value={aircraftvalue}  
            aircraftList={aircraftList || []}          
            onStartValidation={() => {
              setIsAircraftValid(true);
              setAirlineCode("");}
            }
            onCompleteValidation={(isValid: boolean, isAPIError:boolean,aircraft?: AircaftData) => {
              setIsAircraftValid(isValid);
              if (aircraft) {
                setAirlineCode(aircraft.airlineCode);
                setAircraftValue(aircraft.aircraftReg.length === 6 ? aircraft.aircraftReg.substring(1,6) : aircraft.aircraftReg);
              }
            }}
          />  
              </div>
            </div>
            <div className="ComponentDelayListAddInputStn">
              <DCInput
                data-testid="dcStationInput"
                value={stationvalue}
                maxLength={3}
                placeholder="Station"
                required={true}
                disable={false}
                onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setStationValue(e.currentTarget.value.toUpperCase())
                }
              />
            </div>
            <div className="ComponentDelayListAddInputDep">
              <DCInput
                inputMode="numeric"
                value={depflightvalue}
                maxLength={4}
                placeholder="Dep Flight #"
                required={true}
                disable={false}
                onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setDepFlightValue(e.currentTarget.value)
                }
              />
            </div>
            <div className="ComponentAddButton">
              <auro-button
              data-testid="dcAddEntryButton"
                disabled={
                  aircraftvalue === "" ||
                  stationvalue === "" ||
                  depflightvalue === "" ||
                  !isAircraftValid
                    ? "disabled"
                    : undefined
                }
                slim
                secondary
                onClick={() => setDialogOpen(true)}
              >
                Add Entry
              </auro-button>
            </div>
          </>
        )}
        <div className="ComponentAddFilterIcon">
          <ReactSVG
            data-testid="dcExpandCollapseIcon"
            src={isExpanded ? chevronDown : plusIcon}
            onClick={() => setIsExpanded(!isExpanded)}
            beforeInjection={(svg) => {
              svg.classList.add("filtericon");
            }}
          />
        </div>
      </div>
      
      <DCDialog
        open={openDialog}
        onclose={() => cancelDelayEntryEventHandler()}
        header={"Delay Details "}
        size="lg"
      >
        <DelayEntry          
          onCancel={() => cancelDelayEntryEventHandler()}
          onError={(data: string) => errorDelayEntryEventHandler(data)}
          onDelete={()=>deleteRuleEventHandler()}
          aircraft={aircraftvalue}
          flight={depflightvalue}
          station={stationvalue}
          searchDate={searchDate}
          airline={airlineCode}
          source={""}
          MaintDncId={""}
          delayTimeLen={""}
          scheddepart={""}
          actualdepart={""}
          closeDialog={() => cancelDelayEntryEventHandler()}
          onSaveFlightDelayDetail={onSaveFlightDelayDetail}
        />
      </DCDialog>
    </>
  );
};